import axios from 'axios';
import { StatusError } from '@/types/error';

export const parseError = (error: unknown): StatusError => {
  if (axios.isAxiosError(error)) {
    return {
      status: error.response?.status || 500,
      message:
        error.response?.data?.error ||
        error.message ||
        'An unknown error has occurred',
    };
  }

  if (error instanceof Error) {
    return {
      status: 500,
      message: error.message,
    };
  }

  return {
    status: 500,
    message: String(error) || 'An unknown error has occurred',
  };
};
